import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function FAQ({ items, dark = false }) {
  const [openIdx, setOpenIdx] = useState(0);
  if (!items?.length) return null;
  return (
    <div data-testid="faq-section" className={`divide-y ${dark ? "divide-white/10 border-y border-white/10" : "divide-line border-y border-line"}`}>
      {items.map((f, i) => {
        const open = openIdx === i;
        return (
          <div key={i}>
            <button
              data-testid={`faq-question-${i}`}
              aria-expanded={open}
              onClick={() => setOpenIdx(open ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 py-5 text-left"
            >
              <span className={`font-display text-base font-medium sm:text-lg ${dark ? "text-white" : "text-ink"}`}>{f.q}</span>
              <span className={`shrink-0 ${open ? "text-accent" : dark ? "text-slate-500" : "text-steel"}`}>
                {open ? <Minus size={17} /> : <Plus size={17} />}
              </span>
            </button>
            <AnimatePresence initial={false}>
              {open && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.28, ease: "easeInOut" }}
                  className="overflow-hidden"
                >
                  <p data-testid={`faq-answer-${i}`} className={`pb-6 pr-10 text-sm leading-relaxed sm:text-[15px] ${dark ? "text-slate-400" : "text-steel"}`}>
                    {f.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}

export const faqSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
